import store from '@/store'
import _ from 'lodash'
import i18n from '@/core/localization/i18n'

function getApprovalStepsComponentData() {
  const currentErrand = store.getters.currentErrand
  const localErrand = currentErrand.localErrand
  let result = []
  if (!currentErrand || !localErrand) {
    return []
  }
  if (!localErrand.entryApproved && currentErrand.features.useKeyAccess) {
    result.push({ key: 'PolygonKeyAccess' })
  }
  if (localErrand.prelCalcAvailable && !localErrand.prelCalcApproved && currentErrand.features.useCostCalculations) {
    result.push({ key: 'PolygonCostApprove', args: { isPreliminary: true } })
  }
  if (localErrand.calcAvailable && !localErrand.calcApproved && currentErrand.features.useCostCalculations) {
    result.push({ key: 'PolygonCostApprove' })
  }
  return result
}

function getCurrentStep(errand = store.getters.currentErrand) {
  const errandSteps = getErrandSteps(errand)
  return _.find(errandSteps, step => _.some(_.get(step, 'requestStatus.pickedKeys', []), status => status === errand.req_status))
}

function getSteps() {
  return _.keyBy(i18n.t('overview.steps'), step => step.workType.savedValue)
}

function getErrandStatus(errand = store.getters.currentErrand) {
  return _.get(getCurrentStep(errand), 'title')
}

function getStepContainer(errand = store.getters.currentErrand) {
  const steps = getSteps(errand)
  return steps[errand.work_type_id] || steps['Default']
}

function getErrandSteps(errand = store.getters.currentErrand) {
  return _.get(getStepContainer(errand), 'steps', [])
}

export default { getApprovalStepsComponentData, getErrandStatus, getStepContainer, getCurrentStep, getErrandSteps }
